import { render, staticRenderFns } from "./SiteWideBanner.vue?vue&type=template&id=b528adea&scoped=true&"
import script from "./SiteWideBanner.vue?vue&type=script&lang=js&"
export * from "./SiteWideBanner.vue?vue&type=script&lang=js&"
import style0 from "./SiteWideBanner.vue?vue&type=style&index=0&id=b528adea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b528adea",
  null
  
)

export default component.exports